import ProposalBuilder from "work/proposals/__builder/proposal-builder";
import FieldUndoButton from "work/proposals/_views/_buttons/field-undo-button";
import SavedDraftFields from "work/proposals/_views/drafts/saved-draft-fields";
import ProposalField from "work/proposals/proposal-fields/proposal-field";

type DraftFieldUndoButtonProps = {
  field: ProposalField;
  /** The draft as last saved; undefined for a draft that has never been saved, which shows no Undo. */
  savedFields?: SavedDraftFields;
  proposalBuilder: ProposalBuilder;
  disabled?: boolean;
  /**
   * Asked before the saved value goes back, for a field whose Undo can take something else with it.
   * Undo does nothing when it answers false.
   */
  confirmUndo?: () => Promise<boolean>;
  onProposalBuilderUpdated: (updatedProposalBuilder: ProposalBuilder) => void;
};

/**
 * A draft field's Undo: drawn only while the field differs from its saved value, and putting that
 * value back when pressed (#6873). It draws the same {@link FieldUndoButton} an active proposal's
 * redline inputs draw.
 */
export default function DraftFieldUndoButton(props: Readonly<DraftFieldUndoButtonProps>) {
  const { field, savedFields, proposalBuilder, disabled, confirmUndo, onProposalBuilderUpdated } = props;
  if (disabled || !savedFields?.differ(field, proposalBuilder.currentSpec)) return null;

  return (
    <FieldUndoButton
      onUndo={async (event) => {
        // The Client field opens its picker on a click anywhere inside it.
        event.stopPropagation();
        if (confirmUndo && !(await confirmUndo())) return;
        onProposalBuilderUpdated(savedFields.restore(field, proposalBuilder));
      }}
    />
  );
}
